<template>
  <div class="container page lottery-page">
    <van-nav-bar title="" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
     <template #right>
        <button type="button" class="right history-button" @click="$router.push({path:'/GameRecord'});">Voting history</button>
    </template>
    </van-nav-bar>
    <div class="record">
        <div class="period">
            <span class="period-number">{{this.lottery.next_expect}}</span>
            <div class="next-number">
              <van-count-down :time="time" @finish="check()" />
            </div>

        </div>
        <div class="linear-gradient"></div>
        <div class="recent">
          <div class="kuaisan-ball left">
            <span class="res-des middle">{{this.sum}}</span>
          </div>
          <button
            type="button"
            class="result-toggle"
            :aria-expanded="active ? 'true' : 'false'"
            aria-label="Show voting results"
            @click="active = !active"
          >
            <van-icon name="arrow-down" :class="{ up: active,down:!active }" />
          </button>
        </div>
    </div>
    <div class="history_popup"></div>
    <div class="wrapper lottery-content">
        <div class="options-bar">
            <div class="game">
              <div class="sumValueTwoSides">
                <button
                  v-for="(v,key) in lottery_peilv_list"
                  :key="key"
                  type="button"
                  class="rectangle large gift-card"
                  :class="{active:choose[v.type]}"
                  :aria-pressed="choose[v.type] ? 'true' : 'false'"
                  @click="choosePlay(v.type,v.name);"
                >
                  <div class="wrapper gift-card-shell">
                    <div class="content">
                      <van-icon v-if="choose[v.type]" name="success" class="check-icon" aria-hidden="true" />
                      <div class="icon-wrapper">
                        <img :src="'/img/live/10/' + v.type + '.png'" :alt="v.name" class="game-icon">
                      </div>
                      <p class="name-text large">{{v.name}}</p>
                    </div>
                  </div>
                </button>
              </div>
            </div>
        </div>

        <div class="options-bar">
          <section class="watch-live-section" aria-label="Live voting activity">
            <h2 class="watch-header">Watch live vote</h2>
            <div class="vote-list-container">
              <div class="vote-list-wrapper">
                <div class="vote-item" v-for="(item, index) in voteMessages" :key="index">
                  <p class="vote-text">{{item}}</p>
                </div>
                <div class="vote-item" v-for="(item, index) in voteMessages" :key="'dup-' + index">
                  <p class="vote-text">{{item}}</p>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div class="bottom-bar">
          <div class="wrapper" :class="{active:shopping}" v-if="formData.length > 0">
               <div class="vote-panel-header">
                 <span class="choose-title">Choose {{formData.length}} Vote {{money * formData.length || 0}} {{$t("reservation.unit")}}</span>
               </div>
              <div class="vote-input-group">
                <div class="input-wrapper">
                  <span class="input-label">Dot</span>
                  <van-field v-model="money" type="digit" :placeholder="$t('reservation.price_place')" class="vote-input" />
                  <van-button class="rewind-btn" size="small" @click="money = ''">Rewind</van-button>
                </div>
              </div>
              <div class="vote-button-wrapper">
                <van-button class="vote-submit-btn" block @click="jiesuan">Vote</van-button>
              </div>
          </div>
        </div>
      <van-popup v-model="jiesuanpage" get-container="body" class="adaptive-popup">
        <div class="confirm-order-modal adaptive-modal">
            <div class="head van-hairline--bottom">
              <p class="text">{{$t("reservation.task_list")}}</p>
            </div>
            <ul class="list">
                <li v-for="(v,key) in formData" :key="key" class="lise-item van-hairline--bottom">
                    <div class="main">
                      <p class="bet-name">{{ v.name }}</p>
                      <p class="detail-text">1{{$t("reservation.note")}}X{{ money }}{{$t("reservation.unit")}}={{ money }}{{$t("reservation.unit")}}</p>
                    </div>
                    <van-icon @click="clearChooes(v.type)" name="close" />
                </li>
            </ul>
            <div class="sub-bar">
              <van-button class="item cancel-btn" type="default" @click="allClear()">{{$t("reservation.clear_order")}}</van-button>
              <van-button class="item sub-btn" type="default" @click="doSub">{{$t("reservation.submit")}}</van-button>
            </div>
        </div>
      </van-popup>
      <van-popup v-model="active" position="top" :style="{ height: '70%' }" >
              <van-pull-refresh v-model="isLoading" @refresh="onRefresh"  pulling-text=" " loosing-text=" " loading-text="...">
                  <div class="wrapper">
                    <div class="item">
                      <div class="left font-weight">{{$t("reservation.num")}}</div>
                      <div class="right font-weight" >{{$t("reservation.win_num")}}</div>
                    </div>
                    <div class="item" v-for="(v,key) in lottery_list" :key="key">
                      <div class="left font-weight">{{v.expect}}</div>
                      <div class="right font-weight" >
                        <div class="kuaisan-ball left">
                          <span class="res-des middle">{{v.opencode[0] + ' ' + v.opencode[1]}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
              </van-pull-refresh>
        </van-popup>
    </div>
  </div>
</template>

<script>
var time;
var checkTimer = null;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage:false,
      choose: {
        "rose":false,
        "balloon":false,
        "heart":false,
        "rocket":false
      },
      playgame:false,
      shopping:false,
      isLoading: false,
      play:{},
      lottery_peilv_list:{},
      lottery_list:{},
      active: false,
      userInfo:{},
      lottery:{},
      shanzi_1:"0",
      shanzi_2:"0",
      shanzi_3:"0",
      sum:0,
      size:"",
      double:"",
      time:0,
      shopchoose:this.$t("reservation.no_choose"),
      gameitem:"",
      formData:[],
      money:"",
      voteMessages: []
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    doSub(){
      if(this.money === "0"){
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if(this.formData.length === 0){
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }else if(this.money === ""){
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if(this.userInfo.money - (this.money * this.formData.length) < 0 ){
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        }else {
          this.$http({
            method: 'post',
            data:{
               item:this.gameitem,
               money:this.money,
               lid:this.lottery.id,
               mid:this.userInfo.id,
               expect:this.lottery.now_expect
            },
            url: 'game_place_order'
          }).then(res=>{
            if(res.code === 200){
              this.$toast(res.msg);
              this.allClear();
              this.getUserInfo();
            }else if(res.code === 401){
              this.$toast(res.msg);
            }
          })
          return true;
        }
      }
    },
    allClear(){
      for(var i = 0;i<this.formData.length;i++){
          this.choose[this.formData[i]['type']] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem ="";
      this.shopping = false;
      this.jiesuanpage = false;
    },
    jiesuan(){
      if(this.formData.length === 0){
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      }else if(this.money === ""){
        this.$toast(this.$t("reservation.price_place"));
        return false;
      }
      else {
        this.jiesuanpage ? this.jiesuanpage = false : this.jiesuanpage = true;
      }

    },
    clearChooes(type){
      for(var i = 0;i<this.formData.length;i++){
        if(type === this.formData[i]['type'] ){
          this.formData.splice(i,1)
          this.choose[type] = false;
        }
      }
      if(this.formData.length >= 1){
        for(var j = 0;j < this.formData.length;j++){
          if(j === 0){
            this.shopchoose = this.formData[j]['name'];
            this.gameitem = this.formData[j]['type'];
          }else {
            this.shopchoose += ","+this.formData[j]['name'];
            this.gameitem   += "," + this.formData[j]['type'];
          }
        }
      }else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if(this.formData.length === 0){
        this.jiesuanpage = false;
      }
    },
    choosePlay(type,name){
        if(this.choose[type] === true){
          this.choose[type] = false;
          for(var i = 0;i<this.formData.length;i++){
            if(type === this.formData[i]['type'] ){
                this.formData.splice(i,1)
            }
          }
        }else if(this.choose[type] === false) {
          this.formData.push({'name':name, 'type':type})
          this.choose[type] = true;
        }
        if(this.formData.length === 1){
          this.shopping = true;
        }
        if(this.formData.length >= 1){
          for(var j = 0;j < this.formData.length;j++){
            if(j === 0){
              this.shopchoose = this.formData[j]['name'];
              this.gameitem = this.formData[j]['type'];
            }else {
              this.shopchoose += ","+this.formData[j]['name'];
              this.gameitem += ","+this.formData[j]['type'];
            }
          }
        }else {
          this.shopchoose = this.$t("reservation.no_choose");
          this.gameitem = "";
          this.shopping = false;
        }

    },
    check(){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        time = window.setInterval(() => {
          setTimeout(()=>{
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if(count > 5){
              clearInterval(time);
              count = 0;
            }
          },0)
        }, 300)
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getParticipants(){
      this.$http({
        method: 'get',
        url: 'getParticipants'
      }).then(res=>{
        if(res.code === 200){
          console.log(res.voteMessages)
          this.voteMessages = res.data || [];
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryPeilv(){
      this.$http({
        method: 'get',
        data:{id:10},
        url: 'lottery_get_peilv'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_peilv_list = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryList(){
      this.$http({
        method: 'get',
        data:{key:'game1'},
        url: 'lottery_get_one_list'
      }).then(res=>{
        if(res.code === 200){
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getLotteryInfo(){
      this.$http({
        method: 'get',
        data:{key:'game1'},
        url: 'lottery_get_info'
      }).then(res=>{
        console.log(res.data.second)
        if(res.code === 200){
          if(parseFloat(this.userInfo.money) < parseFloat(res.data.condition)){
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({path:'/Home'})
            return false;
          }
          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if(this.time/1000 === 59){
            this.$toast(this.$t("reservation.prize_succ")+this.lottery.now_expect);
          }
          if(res.data.opencode && res.data.opencode.length >= 2) {
            this.sum = res.data.opencode[0] + ' ' + res.data.opencode[1];
          } else {
            this.sum = '';
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })

    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
        this.getUserInfo();
        this.getLotteryInfo();
        this.getLotteryList();
        this.getParticipants();
    }
  },
  destroyed() {
    clearInterval(time);
    if(checkTimer) {
      clearInterval(checkTimer);
      checkTimer = null;
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.nav-bar .right{
  padding-left: 0.21333rem;
  padding-right: 0.21333rem;
  color: #000;
  font-size: 0.34667rem;
  border-radius: 0.26667rem;
  border: 0.05333rem solid #fff;
  line-height: 1.6rem;
}
.record{
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  background-color: #fff;
  box-shadow: 0 0.05333rem 0.05333rem 0 #cacaca;
  z-index: 1;
  border-top: 0.02667rem #cacaca solid;
}
.record .period{
  display: flex;
  align-items: center;
  padding: 0rem 0;
}
.record .period .cover{
  width: 1.6rem;
  height: 1.6rem;
  -o-object-fit: cover;
  object-fit: cover;
}
.record .period .period-number{
  flex: 1;
  margin-left: 0.26667rem;
  margin-right: 0.26667rem;
  height: 1.33333rem;
  line-height: 1.33333rem;
  font-size: 0.43333rem;
  font-weight: 700;
  color: #5b60df;
}
.van-count-down {
  color: #ff253f;
  font-size: 0.5rem;
  float: right;
  line-height: 0.6rem;
}
.linear-gradient{
  width: 100%;
  height: 0.05333rem;
}
.record .recent{
  display: flex;
  align-items: center;
  height: 1.3rem;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 1.86667rem;
  height: 1.86667rem;
  margin-right: 0.8rem;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: left;
  color: #5b60df;
  margin-left: 0.13333rem;
  font-weight: bold;
  text-transform: capitalize
}
.kuaisan-ball .res-des.middle{
  width: 50%;
  font-size: 0.43333rem;
}
.van-icon {
  font-size: .46667rem;
}
.down {
  transition: all .5s;
}
.up{
  transform: rotate(180deg);
  transition: all .5s;
}
.wrapper{
  position: relative;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
.options-bar{
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: auto;
  margin-bottom: 0.53333rem;
  overflow: visible;
}
.watch-live-section{
  width: calc(100% - 1.06667rem);
  background: #fff;
  border-radius: 0.23333rem;
  overflow: hidden;
  box-shadow: 0 0.10667rem 0.32rem rgba(0,0,0,0.1);
  margin: 0 0.53333rem 0.53333rem 0.53333rem;
  border: #5B60DF 1px solid;
}
.watch-header{
  background: linear-gradient(135deg, #5B60DF 0%, #5B60DF 100%);
  color: #fff;
  font-size: 0.35333rem;
  font-weight: 600;
  text-align: center;
  padding: 0.53333rem 0.2rem;
}
.vote-list-container{
  max-height: 6.66667rem;
  overflow: hidden;
  position: relative;
}
.vote-list-wrapper{
  animation: scroll-up 60s linear infinite;
}
.vote-item{
  padding: 0.06667rem 0.16667rem;
  border-bottom: 0.02667rem solid #f0f0f0;
  background: #fff;
}
.vote-item:nth-child(odd){
  background: #f5f5f5;
}
.vote-item:nth-child(even){
  background: #fff;
}
.vote-item:last-child{
  border-bottom: none;
}
.vote-text{
  font-size: 0.28rem;
  color: #666;
  margin: 0;
  padding: 0.2rem;
  line-height: 0.4rem;
}
@keyframes scroll-up {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}
.options-bar .game {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.options-bar .game .tips{
  display: flex;
  align-items: center;
  height: 2.66667rem;
  padding: 0 0.53333rem;
}
.options-bar .game .tips .odds{
  flex: 1;
  font-size: 0.93333rem;
  font-weight: 500;
  color: #ff253f;
}
.options-bar .game .tips .play-tip{
  display: flex;
  align-items: center;
  height: 100%;
}
::v-deep .van-icon-more-o{
  color: #ff253f;
  font-size: 1.33333rem;
}
.options-bar .game .tips .play-tip .span-text{
  margin-left: 0.26667rem;
  font-size: 0.93333rem;
  font-weight: bolder;
  color: #ff253f;
}
.linear-gradient{
  width: 100%;
  height: 2px;
}
.sumValueTwoSides{
  display: flex;
  padding: 1.06667rem 0.53333rem;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.53333rem;
}
.rectangle{
  overflow: hidden;
}
.rectangle.large{
  margin: 0;
  width: calc(50% - 0.26667rem);
  border-radius: 0.53333rem;
  box-shadow: 0 0.10667rem 0.32rem rgba(0,0,0,0.1);
}
.rectangle .wrapper{
  position: relative;
  padding: 0;
  background: #fff;
}
.rectangle .wrapper .content{
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0.8rem 0.53333rem;
}
.rectangle.large .wrapper{
  padding-bottom: 100%;
}
.rectangle .wrapper .content .icon-wrapper{
  width: 2.05336rem;
  height: 2.21336rem;
  margin-bottom: 0.4rem;
}
.rectangle .wrapper .content .game-icon{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.rectangle .wrapper .content .name-text.large{
  font-size: 0.45333rem;
  color: #333;
  font-weight: 600;
  margin: 0;
}
.rectangle .wrapper .content .name-text{
  color: #333;
  font-weight: 600;
}
.rectangle .wrapper .content .check-icon{
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
  font-size: 0.93333rem;
  color: #fff;
}
.rectangle.active .wrapper{
  background: linear-gradient(135deg, #667eea 0%, #667eea 100%);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}
.rectangle.active .wrapper .name-text{
  color: #fff;
}
.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.bottom-bar .bar .left, .bottom-bar .bar{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2.66667rem;
  background-color: #fff;
  box-shadow: 0 0 0.53333rem 0 #cacaca;
  z-index: 2;
}
.bottom-bar .bar .left, .bottom-bar .bar{
  display: flex;
  flex-direction: row;
  align-items: center;
}
.bottom-bar .bar .left .item{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 2.66667rem;
  font-size: 0.53333rem;
}
.bottom-bar .bar .left .item .text{
  font-size: 0.58667rem;
  color: #7d7c7c;
}
.jixuanico{
  font-size: 1.2rem;
}
.bottom-bar .bar .left .line{
  width: 0.05333rem;
  height: 1.33333rem;
  background: #dadada;
}
.bottom-bar .bar .mid{
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.bottom-bar .bar .mid .text{
  font-size: 0.8rem;
  font-weight: 500;
  color: #000;
}
.bottom-bar .bar .mid .text.num{
  margin: 0 0.13333rem;
  color: #ff253f;
}
.bottom-bar .bar .right{
  padding: 0 0.8rem;
  margin: 0 0.8rem;
  color: #fff;
  background: linear-gradient(
      270deg,#e6c3a1,#7e5678);
  font-size: 1.06667rem;
  font-weight: 500;
  height: 1.86667rem;
  line-height: 1.86667rem;
  border-radius: 1.33333rem;
}

::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #5b60df;
  font-size: 0.93333rem;
}
::v-deep   .van-popup {
  position: absolute;
}
::v-deep .van-overlay {
  position: absolute;
  background-color: rgb(70 67 67 / 70%);
}
::v-deep  .van-popup--top {
  top: -0.02667rem;
}
.wrapper .item{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.26667rem 0;
}
.wrapper .item .left{
  width: 40%;
  font-size: 0.35rem;
  text-align: center;
  font-weight: 500;
  color: #5b60df;
}
.font-weight{
  font-weight: 700!important;

}
.wrapper .item .right{
  flex: 1;
  display: flex;
  font-size: 0.36rem;
  justify-content: center;
  overflow: hidden;
  color: #5b60df;
}
.wrapper .item .kuaisan-ball .left{
  justify-content: flex-start;
}
.wrapper .item .kuaisan-ball{
  margin-left: 0.53333rem;
  flex: 1;
  display: flex;
  align-items: center;
}
.wrapper .item .kuaisan-ball .res-img{
  width: 1.33333rem;
  height: 1.33333rem;
  margin-right: 0.53333rem;
}
.wrapper .item .kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #5b60df;
}
.wrapper .item .kuaisan-ball .res-des.middle{
  width: 100%;
  font-size: 0.35rem;
}
.play-type-tip{
  position: unset;
  margin: auto;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 17.33333rem;
  height: 18.66667rem;
  max-height: 50%;
  z-index: 10;
  border-radius: 0.8rem;
  overflow: hidden;
  background-color: #fff;
  color: #000;
}
.play-type-tip .title{
  line-height: 2.4rem;
  background: linear-gradient(
      90deg,#7e5678,#e6c3a1);
  text-align: center;
  color: #fff;
  font-size: 0.93333rem;
  font-weight: 500;
}
.mask{
  background-color: rgb(0 0 0 / 0%);
  animation-duration: 0.35s;
}
.play-type-tip .wrapper{
  height: calc(100% - 0.26667rem);
  background-color: transparent;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.play-type-tip .wrapper .item{
  padding: 1.06667rem 1.33333rem;
  display: flex;
  align-items: flex-start;
}
.play-type-tip .wrapper .item .van-icon{
  color: #e6c3a1;
  font-size: 1.6rem;
}
.play-type-tip .wrapper .item .content .content-title{
  margin-top: 0.58667rem;
  font-size: 0.93333rem;
  font-weight: 500;
  color: #000;
  line-height: 0rem;
}
.play-type-tip .wrapper .item .content .content-detail{
  margin-top: 0.13333rem;
  font-size: 0.58667rem;
  color: #000;
  line-height: 0.8rem;
}
.play-type-tip .wrapper .item .content{
  flex: 1;
  margin-left: 0.8rem;
}

.bottom-bar .wrapper{
  position: absolute;
  top: 0.26667rem;
  left: 0;
  right: 0;
  padding: 0.58669rem 0.32rem;
  background-color: #fff;
  z-index: 1;
  box-shadow: 0 0 0.26667rem 0 #cacaca;
  border-radius: 0.53333rem 0.53333rem 0 0;
  transition: transform .3s cubic-bezier(.21,1.02,.55,1.01);
}
.bottom-bar .wrapper.active{
  transform: translateY(-100%);
}
.vote-panel-header{
  margin-bottom: 0.53333rem;
}
.choose-title{
  font-size: 0.34667rem;
  color: #667eea;
  font-weight: 600;
}
.vote-input-group{
  display: flex;
  flex-direction: column;
  margin-bottom: 0.66667rem;
}
.input-label{
  font-size: 0.33333rem;
  color: #667eea;
  margin-bottom: 0.32rem;
}
.input-wrapper{
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin-top: 0.26667rem;
  margin-bottom: 0.26667rem;
}
.vote-input{
  flex: 1;
  background: #f5f5f5;
  border-radius: 0.26667rem;
  padding: 0 0.4rem;
}
::v-deep .vote-input .van-field__control{
  background: transparent;
  font-size: 0.34667rem;
}
.rewind-btn{
  background: #e8e8e8;
  color: #666;
  border: none;
  padding: 0 0.36667rem;
  height: 0.8rem;
  border-radius: 0.26667rem;
  font-size: 0.29333rem;
}
.vote-button-wrapper{
  margin-top: 0.53333rem;
}
.vote-submit-btn{
  background: linear-gradient(135deg, #667eea 0%, #667eea 100%);
  color: #fff;
  border: none;
  border-radius: 0.32rem;
  height: 1.33333rem;
  padding: 0.45336rem 0.10664rem;
  font-size: 0.5rem;
  font-weight: 600;
}
::v-deep .van-field__control {
  color: #ff253f;
  font-size: 0.34667rem;
  height: 0.8rem;
}
.confirm-order-modal{
  position: unset;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 0 0.53333rem 0.8rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 10.13333rem;
  max-height: 50%;
  z-index: 10;
  background-color: #fff;
  border-radius: 0.8rem;
}
.confirm-order-modal .head{
  position: relative;
  height: 1.1rem;
}
.confirm-order-modal .head .text{
  padding: 0 0.53333rem;
  height: 0.8rem;
  line-height: 0.26667rem;
  text-align: center;
  font-size: 0.53333rem;
  font-weight: 500;
  color: #5b60df;
}
::v-deep .confirm-order-modal .van-hairline--bottom::after {
  border-bottom-width: 0.05333rem;
}
.van-popup--center {
  border-radius: 0.8rem;
  width: 80%;
}
.confirm-order-modal .list{
  flex: 1;
  padding: 0 0.26667rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.confirm-order-modal .list .lise-item{
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.26667rem 0;
}
.confirm-order-modal .list .lise-item .main{
  flex: 1;
  overflow: hidden;
}
.confirm-order-modal .list .lise-item .main .bet-name{
  color: #ff253f;
  font-size: 0.33333rem;
  font-weight: 500;
  line-height: 0.1rem;
  word-wrap: break-word;
  word-break: break-all;
}
.confirm-order-modal .list .lise-item .main  .detail-text{
  line-height: 0rem;
  font-size: 0.36667rem;
  color: #979799;
}
.confirm-order-modal .list .lise-item{
  color: #ff253f;
}
.confirm-order-modal .sub-bar{
  display: flex;
  align-items: center;
  margin-top: 0.8rem;
  justify-content: space-around;
}
.confirm-order-modal .sub-bar .item{
  min-width: 40%;
  height: 0.83333rem;
  text-align: center;
  box-sizing: border-box;
  border-radius: 1.33333rem;
  font-size: 0.33333rem;
  font-weight: 500;
}
.confirm-order-modal .sub-bar .item.cancel-btn{
  border: 0.05333rem solid #979799;
  color: #979799;
  background-color: #fff;
}
.confirm-order-modal .sub-bar .item.sub-btn{
  background: linear-gradient(
      270deg,#5b60df,#5b60df);
  color: #fff;
  border: 0;
}
.next-number span{
  font-size: 0.93333rem;
  font-weight: 700;
  color: #000;
  float: right;
}

/* Victoria Dating Club UI2 */
.lottery-page {
  color: var(--victoria-text);
  background: transparent !important;
}

.lottery-page .nav-bar {
  border-bottom: 1px solid var(--victoria-divider);
}

.nav-bar .history-button {
  min-width: 2.75rem;
  min-height: 1.05rem;
  padding: 0.12rem 0.28rem;
  color: var(--victoria-light-rose);
  font: inherit;
  font-size: 0.3rem;
  line-height: 1.3;
  background: rgba(231, 160, 174, 0.08);
  border: 1px solid rgba(231, 160, 174, 0.2);
  border-radius: 0.36rem;
}

.record {
  z-index: 2;
  margin: 0 0.38rem;
  padding: 0 0.38rem;
  background: rgba(24, 20, 25, 0.9);
  border: 1px solid rgba(255, 209, 217, 0.11);
  border-top: 0;
  border-radius: 0 0 0.42rem 0.42rem;
  box-shadow: var(--victoria-shadow);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.record .period {
  min-height: 1.28rem;
  padding: 0;
}

.record .period .period-number {
  height: auto;
  margin: 0;
  color: var(--victoria-light-rose);
  font-size: 0.4rem;
  line-height: 1.3;
}

.record .next-number {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.record .van-count-down,
.next-number span {
  color: #f2a1b1;
  font-size: 0.46rem;
  line-height: 1;
}

.record .linear-gradient {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255, 209, 217, 0.28), transparent);
}

.record .recent {
  min-height: 1.18rem;
  height: auto;
}

.record .kuaisan-ball .res-des,
.record .kuaisan-ball .res-des.middle {
  width: auto;
  margin-left: 0;
  color: var(--victoria-text);
  font-size: 0.4rem;
  letter-spacing: 0.01rem;
}

.result-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.05rem;
  height: 1.05rem;
  padding: 0;
  color: var(--victoria-primary);
  background: transparent;
  border: 0;
  border-radius: 50%;
}

.result-toggle .van-icon {
  color: inherit;
  font-size: 0.48rem;
}

.lottery-content {
  padding: 0.38rem 0 calc(0.55rem + env(safe-area-inset-bottom));
}

.lottery-content > .options-bar {
  margin-bottom: 0.42rem;
}

.sumValueTwoSides {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.42rem;
  padding: 0.24rem 0.52rem 0.42rem;
}

.rectangle.large.gift-card {
  width: 100%;
  min-width: 0;
  min-height: 0;
  margin: 0;
  padding: 0;
  overflow: visible;
  color: var(--victoria-text);
  font: inherit;
  text-align: center;
  background: transparent;
  border: 0;
  border-radius: 0.5rem;
  box-shadow: none;
  transition: transform 0.2s ease;
}

.gift-card:active {
  transform: scale(0.98);
}

.rectangle .gift-card-shell {
  overflow: hidden;
  background: linear-gradient(145deg, rgba(43, 34, 40, 0.94), rgba(22, 19, 23, 0.96));
  border: 1px solid rgba(231, 160, 174, 0.16);
  border-radius: 0.5rem;
  box-shadow: 0 0.26rem 0.66rem rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.035);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.rectangle.active .gift-card-shell {
  background: linear-gradient(145deg, rgba(118, 66, 80, 0.94), rgba(45, 29, 37, 0.97));
  border-color: rgba(255, 209, 217, 0.68);
  box-shadow: 0 0.28rem 0.78rem rgba(207, 127, 145, 0.28), inset 0 0 0 1px rgba(255, 209, 217, 0.12);
}

.rectangle .gift-card-shell .content {
  padding: 0.5rem 0.38rem;
}

.rectangle .gift-card-shell .content .icon-wrapper {
  width: 1.78rem;
  height: 1.9rem;
  margin-bottom: 0.26rem;
  filter: drop-shadow(0 0.16rem 0.24rem rgba(0, 0, 0, 0.28));
}

.rectangle .gift-card-shell .content .name-text.large,
.rectangle.active .gift-card-shell .content .name-text {
  color: var(--victoria-text) !important;
  font-size: 0.4rem;
  font-weight: 600;
  line-height: 1.3;
}

.rectangle.active .gift-card-shell .content .name-text {
  color: var(--victoria-light-rose) !important;
}

.rectangle .gift-card-shell .content .check-icon {
  top: 0.28rem;
  right: 0.28rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 0.56rem;
  height: 0.56rem;
  color: #2a1920;
  font-size: 0.35rem;
  background: var(--victoria-light-rose);
  border-radius: 50%;
  box-shadow: 0 0.12rem 0.3rem rgba(231, 160, 174, 0.32);
}

.gift-card:focus-visible,
.history-button:focus-visible,
.result-toggle:focus-visible {
  outline: 2px solid var(--victoria-light-rose);
  outline-offset: 2px;
}

.watch-live-section {
  width: auto;
  margin: 0 0.52rem 0.52rem;
  overflow: hidden;
  background: rgba(25, 22, 26, 0.92);
  border: 1px solid rgba(231, 160, 174, 0.18);
  border-radius: 0.44rem;
  box-shadow: var(--victoria-shadow);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.watch-header {
  margin: 0;
  padding: 0.42rem 0.25rem;
  color: #28191e;
  font-size: 0.35rem;
  font-weight: 700;
  letter-spacing: 0.015rem;
  background: var(--victoria-action);
}

.vote-list-container {
  max-height: 5.6rem;
  background: rgba(12, 10, 13, 0.72);
}

.vote-item,
.vote-item:nth-child(odd),
.vote-item:nth-child(even) {
  padding: 0.06rem 0.18rem;
  background: rgba(27, 23, 28, 0.82);
  border-bottom: 1px solid var(--victoria-divider);
}

.vote-item:nth-child(even) {
  background: rgba(36, 29, 34, 0.82);
}

.vote-text {
  padding: 0.22rem;
  color: var(--victoria-text-muted);
  font-size: 0.29rem;
  line-height: 1.5;
}

.bottom-bar {
  position: absolute;
  z-index: 100;
}

.bottom-bar .wrapper {
  top: 0;
  padding: 0.52rem 0.42rem calc(0.48rem + env(safe-area-inset-bottom));
  background: rgba(21, 18, 22, 0.98);
  border: 1px solid rgba(255, 209, 217, 0.13);
  border-bottom: 0;
  border-radius: 0.52rem 0.52rem 0 0;
  box-shadow: 0 -0.3rem 0.8rem rgba(0, 0, 0, 0.38);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
}

.vote-panel-header {
  margin-bottom: 0.3rem;
}

.choose-title,
.input-label {
  color: var(--victoria-light-rose);
}

.vote-input-group {
  margin-bottom: 0.36rem;
}

.bottom-bar .input-wrapper {
  padding: 0.12rem;
  background: rgba(11, 9, 12, 0.72) !important;
  border: 1px solid var(--victoria-border);
  border-radius: 0.38rem;
}

.bottom-bar .vote-input {
  min-height: 1.05rem;
  background: transparent !important;
}

::v-deep .bottom-bar .vote-input .van-field__control {
  height: auto;
  color: var(--victoria-text);
}

.rewind-btn {
  min-height: 0.9rem;
  color: var(--victoria-light-rose);
  background: rgba(231, 160, 174, 0.1);
  border: 1px solid rgba(231, 160, 174, 0.18);
  border-radius: 0.3rem;
}

.vote-submit-btn {
  min-height: 1.24rem;
  height: auto;
  color: #28191e;
  background: var(--victoria-action);
  border-radius: 0.62rem;
  box-shadow: 0 0.22rem 0.6rem rgba(207, 127, 145, 0.26);
}

::v-deep .lottery-page + .van-popup,
::v-deep .van-popup--top {
  color: var(--victoria-text);
  background: rgba(20, 17, 21, 0.98);
}

::v-deep .van-popup--top .wrapper .item {
  border-bottom: 1px solid var(--victoria-divider);
}

::v-deep .van-popup--top .wrapper .item .left,
::v-deep .van-popup--top .wrapper .item .right,
::v-deep .van-popup--top .kuaisan-ball .res-des {
  color: var(--victoria-text);
}

.confirm-order-modal {
  color: var(--victoria-text);
  background: rgba(24, 20, 25, 0.98);
  border: 1px solid rgba(255, 209, 217, 0.14);
  box-shadow: var(--victoria-shadow);
}

.confirm-order-modal .head .text,
.confirm-order-modal .list .lise-item .main .bet-name {
  color: var(--victoria-light-rose);
}

.confirm-order-modal .list .lise-item .main .detail-text {
  color: var(--victoria-text-muted);
}

.confirm-order-modal .sub-bar .item.cancel-btn {
  color: var(--victoria-text-muted);
  background: transparent;
  border: 1px solid rgba(185, 173, 178, 0.45);
}

.confirm-order-modal .sub-bar .item.sub-btn {
  color: #28191e;
  background: var(--victoria-action);
  border: 0;
}

@media (max-width: 340px) {
  .sumValueTwoSides {
    gap: 0.32rem;
    padding-right: 0.4rem;
    padding-left: 0.4rem;
  }

  .rectangle .gift-card-shell .content .icon-wrapper {
    width: 1.55rem;
    height: 1.65rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .vote-list-wrapper {
    animation: none;
  }

  .gift-card,
  .rectangle .gift-card-shell,
  .up,
  .down {
    transition: none;
  }
}
</style>
